var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3281 15.5625C17.0601 15.5625 15.9211 16.1249 15.147 17.0132L9.58781 13.616C9.783 13.1307 9.89062 12.6011 9.89062 12.0469C9.89062 11.4903 9.78202 10.9586 9.58533 10.4717L15.1515 6.99173C15.9254 7.8772 17.0625 8.4375 18.3281 8.4375C20.6543 8.4375 22.5469 6.54497 22.5469 4.21875C22.5469 1.89253 20.6543 0 18.3281 0C16.0019 0 14.1094 1.89253 14.1094 4.21875C14.1094 4.77534 14.218 5.307 14.4147 5.79394L8.8485 9.27389C8.07459 8.38842 6.9375 7.82812 5.67188 7.82812C3.34566 7.82812 1.45312 9.72066 1.45312 12.0469C1.45312 14.3731 3.34566 16.2656 5.67188 16.2656C6.93989 16.2656 8.07891 15.7032 8.85295 14.8149L14.4122 18.2122C14.217 18.6975 14.1094 19.227 14.1094 19.7812C14.1094 22.1075 16.0019 24 18.3281 24C20.6543 24 22.5469 22.1075 22.5469 19.7812C22.5469 17.455 20.6543 15.5625 18.3281 15.5625ZM18.3281 1.40625C19.8789 1.40625 21.1406 2.66794 21.1406 4.21875C21.1406 5.76956 19.8789 7.03125 18.3281 7.03125C16.7773 7.03125 15.5156 5.76956 15.5156 4.21875C15.5156 2.66794 16.7773 1.40625 18.3281 1.40625ZM5.67188 14.8594C4.12106 14.8594 2.85938 13.5977 2.85938 12.0469C2.85938 10.4961 4.12106 9.23438 5.67188 9.23438C7.22269 9.23438 8.48438 10.4961 8.48438 12.0469C8.48438 13.5977 7.22269 14.8594 5.67188 14.8594ZM18.3281 22.5938C16.7773 22.5938 15.5156 21.3321 15.5156 19.7812C15.5156 18.2304 16.7773 16.9688 18.3281 16.9688C19.8789 16.9688 21.1406 18.2304 21.1406 19.7812C21.1406 21.3321 19.8789 22.5938 18.3281 22.5938Z",
    fill: "#D2042D"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.1280a49294c72dd3849b5e9a32aec662.svg";
export { ForwardRef as ReactComponent };